export default {
    loaded: "lucky.wheel.loaded",
    opened: "lucky.wheel.opened",
    wheel: {
        toggleButton: "lucky.wheel.wheel.toggle.button",
        update: "lucky.wheel.wheel.update"
    },
    timeout: "lucky.wheel.timeout",
    prize: "lucky.wheel.prize",
    togglePrizeButton: "lucky.wheel.prize_button",
    spin: "lucky.wheel.spin"
}